import React from 'react';
import Card from '../../../components/Card';
import Switch from '../../../components/Switch';
import TextInput from '../../../components/TextInput';
import Dropdown from '../../../components/Dropdown';
import styles from './OtherInformations.module.sass';

const SOCIAL_DIET_OPTIONS = [
  { value: '1', title: '1 - MSA' },
  { value: '2', title: '2 - URSSAF' },
];

const OtherInformations = ({ student, onStudentChange, onSwitchChange, onDropdownChange }) => {
  return (
    <Card className={styles.card} title="Informations santé" classTitle="title-green">
      <div className={styles.group}>

        <TextInput
          className={styles.field}
          label="N° de sécurité sociale (NIR)"
          name="nir_code"
          type="text"
          placeholder="N° NIR"
          value={student?.nir_code || ''}
          onChange={onStudentChange}
        />

        <div className={styles.field}>
          <Dropdown
            className={styles.dropdown}
            label="Régime social"
            name="social_diet"
            type="text"
            required
            options={SOCIAL_DIET_OPTIONS}
            setValue={(option) => onDropdownChange('social_diet', option.value)}
            value={SOCIAL_DIET_OPTIONS.find(opt => opt.value === student?.social_diet) || ''}
          />
        </div>


        <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginLeft: '10px' }}>Inscrit sur la liste des sportifs de haut niveau :</span>
          <Switch
            name="high_level_sport"
            value={student?.high_level_sport || false}
            onChange={(value) => onSwitchChange('high_level_sport', value)}
            className={styles.switch}
          />
        </div>

        <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginLeft: '10px' }}>Bénéficie de droits attachés à la RQTH :</span>
          <Switch
            name="is_rqth"
            value={student?.is_rqth || false}
            onChange={(value) => onSwitchChange('is_rqth', value)}
            className={styles.switch}
          />
        </div>

        <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginLeft: '10px' }}>Extension BOE :</span>
          <Switch
            name="is_boe"
            value={student?.is_boe || false}
            onChange={(value) => onSwitchChange('is_boe', value)}
            className={styles.switch}
          />
        </div>

        <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginLeft: '10px' }}>Déclare bénéficier de la reconnaissance travailleur handicapé :</span>
          <Switch
            name="is_disabled"
            value={student?.is_disabled || false}
            onChange={(value) => onSwitchChange('is_disabled', value)}
            className={styles.switch}
          />
        </div>
      </div>
    </Card>
  );
};

export default OtherInformations;
